// V5.10.16: Aktif Kumbara Hesaplama Fonksiyonu
// Tüm anasayfalarda aynı mantığı kullanmak için ortak fonksiyon

/**
 * Sahada aktif kumbara sayısını hesaplar
 * 
 * Mantık:
 * - Aktif kumbara = kumbaralar collection'ında olan kumbaralar
 * - "İşletmeden çıkar" seçeneği ile teslim edilenler kumbaralar'dan silinir → Aktif listeden çıkar
 * - "Yeni kumbara bırak" seçeneği ile teslim edilenler → Eski kumbara kumbaralar'dan çıkar, yeni kumbara eklenir → Aktif listede kalır (yeni kumbara ile)
 * - "Aynı ID ile devam et" seçeneği ile teslim edilenler → Aynı kumbara kumbaralar'da kalır (ID: 200-1) → Aktif listede kalır
 * - Açılan kumbaralar → Aktif listeden çıkar (artık sahada değil)
 * 
 * @param {Array} kumbaralar - Tüm kumbaralar (kumbaralar collection)
 * @param {Array} teslimEdilenler - Teslim edilen kumbaralar (teslimEdilenler collection)
 * @param {Array} acilmisKumbaralar - Açılan kumbaralar (acilmisKumbaralar collection)
 * @returns {number} Sahada aktif kumbara sayısı
 */
export const sahadaAktifHesapla = (kumbaralar, teslimEdilenler, acilmisKumbaralar) => {
  // V5.10.18: aktifKumbaralariFiltrele fonksiyonunu kullan (tutarlılık için)
  return aktifKumbaralariFiltrele(kumbaralar, acilmisKumbaralar).length;
};

/**
 * Aktif kumbaraları filtreler (sayı hesaplama için değil, liste gösterme için)
 * 
 * @param {Array} kumbaralar - Tüm kumbaralar
 * @param {Array} acilmisKumbaralar - Açılan kumbaralar
 * @returns {Array} Aktif kumbaralar listesi
 */
export const aktifKumbaralariFiltrele = (kumbaralar, acilmisKumbaralar) => {
  // V5.10.22: Basit ID eşleştirmesi (versiyonlu ID yok, sadece direkt eşleşme)
  if (!Array.isArray(kumbaralar)) return [];
  if (!Array.isArray(acilmisKumbaralar)) {
    // Açılmış kumbaralar yoksa sadece durum filtresi uygula
    return kumbaralar.filter(k => k && k.durum !== 'İşletme Kapandı' && k.durum !== 'Çalındı/Yok');
  }
  
  const acilanKombinasyonlar = new Set();
  acilmisKumbaralar.forEach(a => {
    if (a && a.id && a.firmaAdi) {
      const kombinasyon = `${a.firmaAdi}_${a.id}`;
      acilanKombinasyonlar.add(kombinasyon);
    }
  });
  
  const sonuc = kumbaralar.filter(k => {
    if (!k) return false;
    
    // Durum kontrolü
    if (k.durum === 'İşletme Kapandı' || k.durum === 'Çalındı/Yok') {
      return false;
    }
    
    // Açılan kumbaralar → Aktif listeden çıkar (artık sahada değil)
    const kombinasyon = `${k.firmaAdi}_${k.id}`;
    if (acilanKombinasyonlar.has(kombinasyon)) {
      return false;
    }
    
    return true; // Aktif listede kalır
  });
  
  // V5.10.25: KESIN LOG - console.error her zaman görünür
  console.error('🔍 aktifKumbaralariFiltrele ÇALIŞTI - KESIN LOG:', {
    toplamKumbara: kumbaralar.length,
    acilmisKumbara: acilmisKumbaralar.length,
    acilanKombinasyonSayisi: acilanKombinasyonlar.size,
    aktifKumbara: sonuc.length,
    hesaplama: `${kumbaralar.length} - ${kumbaralar.length - sonuc.length} = ${sonuc.length}`,
    timestamp: new Date().toISOString()
  });
  
  return sonuc;
};
